import { render, staticRenderFns } from "./demandrecList.vue?vue&type=template&id=3a026402&"
import script from "./demandrecList.vue?vue&type=script&lang=js&"
export * from "./demandrecList.vue?vue&type=script&lang=js&"
import style0 from "./demandrecList.vue?vue&type=style&index=0&id=3a026402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports